export default {
  presenter: 'caletka',
  title: 'Netiketa v e-mailové komunikaci',
  subtitle: 'začátečníci',
  text: `
I na internetu platí určitá pravidla. V případě netikety za jejich nedodržování nehrozí žádný
postih, ale pokud je budete ignorovat a zároveň třeba žádat o pomoc, nemůžete počítat s úspěchem.
V přednášce se budeme zabývat moderními nešvary, jakými je top posting, krádeže vláken, či špatné
adresování výzev o odhlášení z konference. A řekneme si i, jaký je rozdíl mezi poli To: a Cc:
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/caletka-netiketa.js